/**
 * Module
 */
require('./app/app.module.js');

/**
 * Constants
 */
require('./app/app.constants.js');

/**
 * Directives
 */
require('./app/widgets/fin.directives.js');
require('./app/widgets/finCalendar/finCalendarDrct.js');
require('./app/widgets/finSpinner/finSpinnerDrct.js');
require('./app/widgets/finFuna/finFunaDrct.js');
require('./app/widgets/finFuna/finFunaSrvc.js');
require('./app/widgets/finNessunRisultato/finNessunRisultatoDrct.js');
require('./app/widgets/finTable/finTableDrct.js');
require('./app/widgets/finRicercaStrumento/finRicercaStrumentoDrct.js');
require('./app/widgets/finNumeric/finNumericDrct.js');
require('./app/widgets/finModali/iniziativa/finModaleIniziativaCtrl.js');
require('./app/widgets/finDossierHeader/finDossierHeaderDrct.js');
require('./app/widgets/finDossierComposition/finDossierCompositionDrct.js');
require('./app/widgets/finDossierComposition/finDossierCompositionSrvc.js');
require('./app/widgets/finDossierMovements/finDossierMovementsDrct.js');
require('./app/widgets/finDossierMovements/finDossierMovementsSrvc.js');
require('./app/widgets/finDossierChartPane/finDossierChartPaneDrct.js');
require('./app/widgets/finDossierChartPane/finDossierChartPaneSrvc.js');
require('./app/widgets/finModali/info-tooltip/finInfoTooltip.js');

/**
 * FILLER PER FXC
 */
require('./app/widgets/cblCalendar/cblCalendarDrct.js');

/**
 * Components
 */
require('./app/components/operazioni/operazioni.cmpt.js');
require('./app/components/sceltaDossier/sceltaDossier.cmpt.js');
require('./app/components/abilitaConsulenza/abilitaConsulenza.cmpt.js');
require('./app/components/saldoDossier/saldoDossier.cmpt.js');
require('./app/components/schedaDossier/schedaDossierCtrl.js');
require('./app/components/schedaDossier/schedaDossierSrvc.js');
require('./app/components/listaRaccomandazioni/listaRaccomandazioni.cmpt.js');
require('./app/components/gestioneRaccomandazione/gestioneRaccomandazione.cmpt.js');
require('./app/components/gestioneProposta/gestioneProposta.cmpt.js');
require('./app/components/gestioneRichiesta/gestioneRichiesta.cmpt.js');
require('./app/components/gestioneOrdine/gestioneOrdine.cmpt.js');
require('./app/components/modalScontoMassivo/modalScontoMassivo.ctrl.js');
require('./app/components/modalAlert/modalAlert.cmpt.js');
require('./app/components/modalAlertProposte/modalAlertProposte.ctrl.js');

/**
 * Services
 */
require('./app/components/servicesUtilities/finDeskSrvc.js');
require('./app/components/servicesUtilities/finLabelSrvc.js');
require('./app/components/servicesUtilities/finMappingSrvc.js');
require('./app/components/servicesUtilities/finMessaggiFctr.js');
require('./app/components/servicesUtilities/finPaginatoreSrvc.js');
require('./app/components/servicesUtilities/finDomainSrvc.js');
require('./app/components/servicesUtilities/finUserSrvc.js');
require('./app/components/servicesUtilities/finLoggerSrvc.js');
require('./app/components/servicesUtilities/finBrioSrvc.js');
require('./app/components/modalAlert/modalAlert.srvc.js');
require('./app/widgets/finUpload/finUploadSrvc.js');
require('./app/components/gestioneRaccomandazione/gestioneRaccomandazione.srvc.js');
require('./app/components/servicesUtilities/finInserimentoFcts.js');
require('./app/components/cashflow/cashflow.cmpt.js');
require('./app/components/cashflow/cashflow.srvc.js');
require('./app/components/cashflow/cashflow.table.srvc.js');
require('./app/components/estrattoconto/estrattoconto.cmpt.js');
require('./app/components/estrattoconto/estrattoconto.srvc.js');
require('./app/components/estrattoconto/estrattoconto.table.srvc.js');
require('./app/widgets/finModali/info-tooltip/finInfoTooltip.js');
require('./app/widgets/finUpload/finUploadSrvc.js');
/**
 * Run
 */
require('./app/app.run.js');

/**
 * Config
 */
require('./app/app.route.js');


/*****************
 ** WEBPACK FOOTER
 ** ./entryRoute.js
 ** module id = 0
 ** module chunks = 1
 **/